/* rs-pdp-wishlist-place.js - relocates Swish's hydrated <wishlist-button-block> into the PDP title row (desktop) or
   the gallery (mobile). What does and does not work, and why placement is self-healing: the comment above the
   loader in snippets/block.product-title.liquid. launch readiness pass 2, 2026-09-24: moved out of the inline <script>; loaded with
   `defer` - it already polls for hydration and waits for DOMContentLoaded, so timing is unchanged. Idempotent (window guard). */
(function () {
  if (window.__rsSwishPdpPlace) return;
  window.__rsSwishPdpPlace = true;

  var mq = window.matchMedia('(max-width: 768px)');
  var slot = null;

  function place(tries) {
    tries = tries || 0;
    var btn = document.querySelector('wishlist-button-block');
    var row = document.querySelector('.rs-pdp-title-row');
    if (!btn || !row) {
      if (tries < 60) setTimeout(function () { place(tries + 1); }, 100);
      return;
    }

    /* Wait for hydration — moving it before the app renders leaves it empty. */
    if (!btn.hasAttribute('wk-loaded')) {
      if (tries < 60) setTimeout(function () { place(tries + 1); }, 100);
      return;
    }

    /* Remember the app-block wrapper so the vacated slot doesn't hold space
       in the .layout-stack gap. */
    if (!slot) {
      var parent = btn.parentElement;
      if (parent && parent.classList.contains('shopify-app-block')) slot = parent;
    }

    /* PDP 2026 look (John 2026-10-21): the heart lives in the title row on desktop. Phone PDP redesign
       (John's mockup, 2026-11-03): on phones it sits on the PHOTO again, top-right, placed below the transparent
       header (top = --rs-header-h + 10px, the same offset the NEW pill uses) so it never lands under the header
       icons. The gallery-rebuild self-healing below is what keeps it there. */
    var gallery = document.querySelector('.product__main-photos');
    var target = (mq.matches && gallery) ? gallery : row;

    if (btn.parentElement !== target) target.appendChild(btn);
    if (slot) slot.style.display = 'none';
  }

  /* Placement has to be self-healing, not one-shot. On mobile the heart is
     parented to the flickity gallery, and the gallery rebuilds its children
     on interaction -- which sweeps the heart out and makes it vanish right
     after a tap. Re-assert placement whenever the node ends up somewhere it
     should not be, rather than trying to enumerate every flickity event. */
  function ensure() { place(0); }

  var observer = new MutationObserver(function () {
    var btn = document.querySelector('wishlist-button-block');
    if (!btn) return;
    var wanted = (mq.matches && document.querySelector('.product__main-photos')) || document.querySelector('.rs-pdp-title-row');
    /* Only act when it has actually drifted — re-placing it fires this
       observer again, and the guard is what stops that looping. */
    if (wanted && btn.parentElement !== wanted) ensure();
  });

  function watch() {
    var scope = document.querySelector('.product-grid__container') || document.body;
    observer.observe(scope, { childList: true, subtree: true });
  }

  /* A tap is the moment the gallery is most likely to rebuild. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('wishlist-button-block')) {
      setTimeout(ensure, 250);
      setTimeout(ensure, 1000);
    }
  }, true);

  if (document.readyState !== 'loading') { place(); watch(); }
  else { document.addEventListener('DOMContentLoaded', function () { place(); watch(); }); }
  mq.addEventListener('change', function () { place(); });
})();
